import React from 'react';

import classNames from 'classnames';
import closeIcon from 'assets/icons/close-icon.svg';
import Table from 'components/Table';

import './styles.css';

const StatisticsBox = ({data, show, closeBox}) => (
  <div className={classNames('StatisticsBox', {active: show})}>
    <div className="header colab-row-space-between">
      Allocations Statistics
      <div className="closeButton">
        <img src={closeIcon} alt="close" onClick={closeBox} />
      </div>
    </div>
    <div className="content">
      <Table>
        <Table.Header>
          <Table.HeaderItem heading="Room Type" />
          <Table.HeaderItem heading="No" className="realColumn" />
          <Table.HeaderItem heading="Dummy" className="dummyColumn" />
        </Table.Header>
        <Table.Body>
          {data.map(roomType => (
            <Table.Row key={roomType.key}>
              <Table.Cell>{roomType.label}</Table.Cell>
              <Table.Cell className="dataCell">
                {roomType.currentlySelected}/{roomType.totalReal}
              </Table.Cell>
              <Table.Cell className="dataCell">
                {roomType.currentlySelectedDummy}/{roomType.totalDummy}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </div>
  </div>
);

export default StatisticsBox;
